import { render, staticRenderFns } from "./BottonmMenu3.vue?vue&type=template&id=50a66714"
import script from "./BottonmMenu3.vue?vue&type=script&lang=js"
export * from "./BottonmMenu3.vue?vue&type=script&lang=js"
import style0 from "./BottonmMenu3.vue?vue&type=style&index=0&id=50a66714&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports